module.exports = __webpack_public_path__ + "img/last_duration_min.030ddc14.svg";